import { OwcIconButton, OwcTypography } from "@one/react";
import React from "react";
import styles from "./EquipmentTitle.module.scss";
const EquipmentTitleBar = ({isEditMode,showTextValue}) => {
  return (
    <div className={styles.equipmentpageTitleIcon}>
      {showTextValue?<OwcTypography variant="button">My Lab - Bulk Edit</OwcTypography>:
        <OwcTypography variant="button">My lab</OwcTypography>}
      <OwcIconButton flat type="outlined" icon="more_vertical" />
    </div>
  );
};

export default EquipmentTitleBar;
